import request from '@/utils/market/marketing'
// 经销商列表
export function selectByUuid(query) { // 消费者查询
    return request({
      url: '/mtscitech/back/logawardstuffinfuse/selectByUuid',
      method: 'get',
      params: query
    })
  }
  export function logawardstuffinfuseadd(data) { // 奖池注入充值
    return request({
      url: '/mtscitech/back/logawardstuffinfuse/add',
      method: 'post',
      data
    })
  }
  export function logawardstuffinfuseupdateState(query) { // 改状态
    return request({
      url: '/mtscitech/back/logawardstuffinfuse/updateState',
      method: 'get',
      params: query
    })
  }
  // 奖池管理
  export function findlistbytype(query) { // 根据类型获取奖品池
    return request({
      url: '/mtscitech/back/awardstuffpool/findlistbytype',
      method: 'get',
      params: query
    })
  }
  export function poolfindall(query) { // 获取奖品池
    return request({
      url: '/mtscitech/back/awardstuffpool/findall',
      method: 'get',
      params: query
    })
  }
  export function addawardstuff(data) { // 新增奖池
    return request({
      url: '/mtscitech/back/awardstuffpool/addawardstuff',
      method: 'post',
      data
    })
  }
  export function awardstuffpooldelete(query) { // 删除奖池
    return request({
      url: '/mtscitech/back/awardstuffpool/delete',
      method: 'get',
      params: query
    })
  }
  export function updateawardstuff(data) { // 修改奖池
    return request({
      url: '/mtscitech/back/awardstuffpool/updateawardstuff',
      method: 'post',
      data
    })
  }
  export function poolupdateState(query) { // 更新奖池状态
    return request({
      url: '/mtscitech/back/awardstuffpool/updateState',
      method: 'get',
      params: query
    })
  }